import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "phone"
const PhoneIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.164 2.32C6.904 1.58 8.156 1.806 8.59 2.76L10.578 7.134C10.837 7.704 10.716 8.374 10.274 8.816L8.74 10.35C8.997 11.324 9.515 12.26 10.295 13.04 11.075 13.817 12.008 14.334 12.983 14.591L14.516 13.059C14.958 12.618 15.628 12.495 16.197 12.754H16.198L20.573 14.743C21.526 15.176 21.753 16.428 21.013 17.169L17.801 20.381C17.545 20.638 17.2 20.738 16.871 20.698 13.525 21.289 9.448 19.984 6.4 16.935 3.349 13.884 2.043 9.807 2.634 6.46 2.594 6.133 2.696 5.788 2.95 5.532zM4.162 6.443 4.132 6.599C3.584 9.413 4.665 13.079 7.46 15.873 10.254 18.668 13.919 19.748 16.733 19.201L16.89 19.17 19.952 16.108 15.577 14.12 13.47 16.228 13.079 16.152C11.679 15.882 10.33 15.195 9.234 14.099 8.14 13.004 7.451 11.655 7.18 10.255L7.105 9.864 9.213 7.756 7.224 3.38z" />
        </svg>
      }
    </span>
  )
}
export default PhoneIcon
